

export default {
    name: 'JdDetailBody',
    props: {
        jd: Object,
    },
}
